import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: 16,
    margin: '8px 0'
  },
  header: {
    marginBottom: 16
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.grey[500],
    fontSize: 13,
    marginTop: 6
  },

  list: {
    marginTop: 16
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 0',
    borderTop: `1px solid ${theme.palette.grey[300]}`
  },

  left: {
    fontWeight: 600,
    color: theme.palette.grey[700]
  },

  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },

  time: {
    fontSize: 12,
    color: '#8A94A6'
  },
  iconText: { fontWeight: 500 },
  skeleton: { width: 60 }
}))
export default useStyles
